<be-edition-row [class]="'dialog-row ' + (cien ? 'cien' : '')"
                *ngFor="let property of propertiesToShow; trackBy: trackByModelKey"
                [property]="property" [formGroup]="formGroup" (deleteButton)="deleteButton"
                [formManager]="formManager" [callbackFunctionForDeleteButton]="callbackFunctionForDeleteButton">
</be-edition-row>
